import React from 'react';
import { TablePagination } from '@material-ui/core';
import { IPagination } from './types';

export const Pagination = ({
    page,
    setPage,
    limit,
    setLimit,
    total,
    limitOptions = [5, 10, 25],
    ...props
}: IPagination) => {
    const handlePageChange = (
        event: React.MouseEvent<HTMLButtonElement> | null,
        newPage: number
    ) => setPage(newPage);

    const handleLimitChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPage(0);
        setLimit(parseInt(event.target.value));
    };

    return (
        <TablePagination
            component="div"
            count={total ?? 0}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleLimitChange}
            page={page}
            rowsPerPage={limit}
            rowsPerPageOptions={limitOptions}
            {...props}
        />
    );
};
